import { createSelector } from 'reselect';
import { pathOr, prop } from 'ramda';

const localState = prop('organizations');

export const getOrganizationsEntry = createSelector(
  localState,
  pathOr([], ['data', 'entry']),
);

export const getOrganizationsLoading = createSelector(
  localState,
  prop('loading'),
);

export const getOrganizationsShouldShowLoading = createSelector(
  [getOrganizationsLoading, getOrganizationsEntry],
  (loading, data) => loading && !data,
);
